// test2648
(2648 && 0);
